import { render, staticRenderFns } from "./ToastsDemand.vue?vue&type=template&id=118156e9"
import script from "./ToastsDemand.vue?vue&type=script&lang=js"
export * from "./ToastsDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports